import { useState } from "react";
import { Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { useStore } from "@/context/StoreContext";

export default function Contact() {
  const { settings } = useStore();
  const [form, set] = useState({ name: "", email: "", order_number: "", message: "" });
  const [state, setState] = useState("idle");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setState("sending");
    setError("");
    try {
      await api.post("/contact", form);
      setState("sent");
    } catch (err) {
      setError(errMsg(err));
      setState("idle");
    }
  };

  return (
    <div className="max-w-6xl mx-auto px-5 sm:px-8 pt-16 sm:pt-24 grid md:grid-cols-[1fr_1.3fr] gap-16" data-testid="contact-page">
      <div>
        <p className="eyebrow">Support</p>
        <h1 className="font-display text-5xl sm:text-6xl font-extrabold tracking-tighter uppercase text-white mt-4">Contact</h1>
        <p className="mt-6 text-zinc-400 max-w-sm">Questions about an order, shipping, or a piece? Send us a message and we'll get back to you.</p>
        <div className="mt-10 space-y-3 text-sm">
          {settings?.contact_email && <p><span className="eyebrow mr-3">Email</span><a href={`mailto:${settings.contact_email}`} className="text-white hover:text-zinc-300" data-testid="contact-email-link">{settings.contact_email}</a></p>}
          {settings?.contact_phone && <p><span className="eyebrow mr-3">Phone</span><span className="text-white">{settings.contact_phone}</span></p>}
        </div>
      </div>
      {state === "sent" ? (
        <div className="border border-white/10 bg-[#0a0a0c] p-10 self-start" data-testid="contact-success">
          <h2 className="font-display text-2xl uppercase font-bold">Message sent.</h2>
          <p className="text-zinc-400 mt-3">Thanks for reaching out — we'll reply by email.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          {[["name", "Name", "text"], ["email", "Email", "email"], ["order_number", "Order number (optional)", "text"]].map(([k, l, t]) => (
            <label key={k} className="block">
              <span className="eyebrow block mb-2">{l}</span>
              <input type={t} required={k !== "order_number"} value={form[k]} onChange={(e) => set({ ...form, [k]: e.target.value })} className="store-input" data-testid={`contact-${k.replace("_", "-")}-input`} />
            </label>
          ))}
          <label className="block">
            <span className="eyebrow block mb-2">Message</span>
            <textarea required rows={6} value={form.message} onChange={(e) => set({ ...form, message: e.target.value })} className="store-input resize-none" data-testid="contact-message-input" />
          </label>
          {error && <p className="text-sm text-[#ff6b6b]" data-testid="contact-error">{error}</p>}
          <button className="btn-store" disabled={state === "sending"} data-testid="contact-submit-button">
            {state === "sending" && <Loader2 size={14} className="animate-spin" />} Send message
          </button>
        </form>
      )}
    </div>
  );
}
